import { HelperTire } from './helper-tire.js';

class SearchButton {
  constructor(activator) {
    //this.el = document.getElementById("select_btn_gomme");
    this.el = activator;
    this.el.onclick = (e) => { this.onClick(e); };
    //activator.addEventListener("click", (e) => { this.onClick(e); });
  }

  onClick(evt) {
    var width = document.getElementById("select_width") ? document.getElementById("select_width").value : document.getElementById("select_width_inline") ? document.getElementById("select_width_inline").value : null;
    var ratio = document.getElementById("select_ratio") ? document.getElementById("select_ratio").value : document.getElementById("select_ratio_inline") ? document.getElementById("select_ratio_inline").value : null;
    var diameter = document.getElementById("select_diameter") ? document.getElementById("select_diameter").value : document.getElementById("select_diameter_inline") ? document.getElementById("select_diameter_inline").value : null;
    var brand = document.getElementById("select_brand") ? document.getElementById("select_brand").value : document.getElementById("select_brand_inline") ? document.getElementById("select_brand_inline").value : null;
    var speed = document.getElementById("select_speed") ? document.getElementById("select_speed").value : document.getElementById("select_speed_inline") ? document.getElementById("select_speed_inline").value : null;
    var season = document.getElementById("select_season") ? document.getElementById("select_season").value : document.getElementById("select_season_inline") ? document.getElementById("select_season_inline").value : null;
    var isrunflat = document.getElementById("searchformdata_isrunflat") ? document.getElementById("searchformdata_isrunflat").checked : document.getElementById("chk_runflat_inline") ? document.getElementById("chk_runflat_inline").checked : null;
    var extraload = document.getElementById("searchformdata_extraload") ? document.getElementById("searchformdata_extraload").checked : document.getElementById("chk_extraload_inline") ? document.getElementById("chk_extraload_inline").checked : null;
    var fastdelivery = document.getElementById("searchformdata_24h_inline") ? document.getElementById("searchformdata_24h_inline").checked : document.getElementById("chk_24h_inline") ? document.getElementById("chk_24h_inline").checked : null;

    //var width = document.getElementById("select_width").value;
    //var ratio = document.getElementById("select_ratio").value;
    //var diameter = document.getElementById("select_diameter").value;
    //var brand = document.getElementById("select_brand").value;
    //var speed = document.getElementById("select_speed").value;
    //var season = document.getElementById("select_season").value;
    //var isrunflat = document.getElementById("searchformdata_isrunflat").checked;
    //var extraload = document.getElementById("searchformdata_extraload").checked;

    var ht = new HelperTire();

    window.location.href = ht.ToUrl({ width: width, ratio: ratio, diameter: diameter, brand: brand, speed: speed, season: season, isrunflat: isrunflat, extraload: extraload, fastdelivery: fastdelivery });
  }
}
var ids = ["select_btn_gomme", "horz-submit"];
ids.forEach((id) => {
  var el = document.getElementById(id);
  if (el) {
    window.SearchButton = new SearchButton(el);
  }});
